import _ from 'lodash'

export default {
  methods: {
    whatsappFormatter(text) {
      if (text) {
        let newText = text

        // Helper function to check if content would be valid WhatsApp formatting
        const isValidWhatsAppFormatting = (content) => {
          if (!content) return false
          // Check if content starts or ends with spaces
          return content[0] !== ' ' && content[content.length - 1] !== ' '
        }

        // Replace bold tags with validation
        newText = newText.replace(/<b>(.*?)<\/b>/g, (match, content) => {
          return isValidWhatsAppFormatting(content) ? `*${content}*` : match
        })

        newText = newText.replace(
          /<strong>(.*?)<\/strong>/g,
          (match, content) => {
            return isValidWhatsAppFormatting(content) ? `*${content}*` : match
          }
        )

        // Replace italic tags with validation
        newText = newText.replace(/<i>(.*?)<\/i>/g, (match, content) => {
          return isValidWhatsAppFormatting(content) ? `_${content}_` : match
        })

        newText = newText.replace(/<em>(.*?)<\/em>/g, (match, content) => {
          return isValidWhatsAppFormatting(content) ? `_${content}_` : match
        })

        // Replace strikethrough tags with validation
        newText = newText.replace(
          /<strike>(.*?)<\/strike>/g,
          (match, content) => {
            return isValidWhatsAppFormatting(content) ? `~${content}~` : match
          }
        )

        newText = newText.replace(/<s>(.*?)<\/s>/g, (match, content) => {
          return isValidWhatsAppFormatting(content) ? `~${content}~` : match
        })

        // Replace line breaks
        newText = newText.replace(/<br \/>/g, '\n')

        return newText
      }
    },
    whatsappToPreviewFormatter(text, usingBr = false) {
      if (text) {
        let newText = text
        const regex = {
          bold: /(?<!\*)\*([^*\n]+)\*(?!\*)/g,
          italic: /\b_([^\s][^_]+?[^\s])_\b/g,
          strikethrough: /~\b(\w+(\s+\w+)*|\w+)\b~(?!\w)/g,
          boldItalic: /\b\*_([^\s][^_]+?[^\s])_\*\b/g,
          italicBold: /\b_\*([^\s][^_]+?[^\s])\*_\b/g,
        }

        // Helper function to check if content is valid for formatting
        const isValidFormatting = (content) => {
          if (!content) return false
          return content[0] !== ' ' && content[content.length - 1] !== ' '
        }

        // Process italic bold combinations first
        newText = newText.replace(regex.italicBold, (match, content) => {
          return isValidFormatting(content) ? `<i><b>${content}</b></i>` : match
        })

        newText = newText.replace(regex.boldItalic, (match, content) => {
          return isValidFormatting(content) ? `<b><i>${content}</i></b>` : match
        })

        // Process individual formatting
        newText = newText.replace(regex.bold, (match, content) => {
          return isValidFormatting(content) ? `<b>${content}</b>` : match
        })

        newText = newText.replace(regex.italic, (match, content) => {
          return isValidFormatting(content) ? `<i>${content}</i>` : match
        })

        newText = newText.replace(regex.strikethrough, (match, content) => {
          return isValidFormatting(content)
            ? `<strike>${content}</strike>`
            : match
        })

        if (!usingBr) {
          newText = newText.replace(/\r\n|\n|\r/g, ' <br />')
        }

        // check URL
        newText = this.hubConversationLinkFormatter(newText)
        if (this.$route.query.type === 'comments')
          newText = this.hubConversationUsernameFormatter(newText)
        return newText
      } else {
        return ''
      }
    },
    scrollToBottomConversation() {
      const objDiv = document.getElementById('conv')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    hubConversationFormatter(text) {
      if (text) {
        return this.whatsappToPreviewFormatter(text)
      }
    },
    reformatUrl(url) {
      const isNumericFirst = /^\d+(?:[.,]\d+)*$/gm.test(url)
      if (!isNumericFirst) {
        let redirectUrl = url.includes('http') ? url : 'https://' + url
        redirectUrl = redirectUrl.replace(/[,+()$~'"*<>{}]/g, '') // Symbol punctuation
        redirectUrl = redirectUrl.replace(/<b>(.*?)<\/b>/g, '$1')
        redirectUrl = redirectUrl.replace(/<i>(.*?)<\/i>/g, '$1')
        redirectUrl = redirectUrl.replace(/<strike>(.*?)<\/strike>/g, '$1')
        redirectUrl = redirectUrl.replace(/(.*?)<\/b>/g, '$1')
        redirectUrl = redirectUrl.replace(/(.*?)<\/i>/g, '$1')
        redirectUrl = redirectUrl.replace(/(.*?)<\/strike>/g, '$1')
        redirectUrl = redirectUrl.replace(/<br \/>/g, '\n')
        redirectUrl = redirectUrl.replace(/<br \/>/g, '\n')

        return (
          '<a href="' +
          redirectUrl.replace(/(.*?)<\//g, '$1') +
          '" style="word-break: break-all; color: #4B61DD" target="_blank"><u>' +
          this.whatsappFormatter(url) +
          '</u></a>'
        )
      } else return url
    },
    hubConversationLinkFormatter(text) {
      // Save for later
      let urlRegex
      if (text.includes('//')) {
        urlRegex =
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
      } else {
        urlRegex =
          /[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi
      }

      return text.replace(urlRegex, (url) => this.reformatUrl(url))
      // return text
    },
    bracketClear(message) {
      if (message) {
        if (message) message = message.replaceAll('<', '< ')
        return message
      }
    },
    contentFormatter(message, isRead = false) {
      if (message) {
        let text = isRead ? message : this.sliceWords(message, 253)
        let indexingText = isRead ? message : this.sliceWords(message, 253)
        let currentPoint = 0
        let bunchOfUrls = []
        const outputResponse = []
        const urlRegex =
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi

        text.replace(urlRegex, (url) => {
          // Check if there is currency
          const isUsingCurrency = url[0] + url[1] === 'Rp'
          let extractAfterCurrency = url
          if (isUsingCurrency) extractAfterCurrency = url.split('Rp')[1]
          if (!parseInt(extractAfterCurrency)) {
            const index = []
            index.push(indexingText.indexOf(url))
            index.forEach((idx) => {
              const isUsingProtocol =
                indexingText[idx - 2] === '/' && indexingText[idx - 1] === '/'
              const protocol = indexingText[idx - 4] === 's' ? 'https' : 'http'
              // eslint-disable-next-line no-useless-escape
              // url = url.replace(/[,+()$~'"*<>{}]/g, '') // url punctuation
              bunchOfUrls.push({
                link: isUsingProtocol ? `${protocol}://${url}` : url,
                index: isUsingProtocol
                  ? currentPoint + idx + (protocol.length + 3)
                  : currentPoint + idx,
              })
              indexingText = indexingText.replace(
                isUsingProtocol ? `${protocol}://${url}` : url,
                ''
              )
              currentPoint =
                (isUsingProtocol
                  ? currentPoint + idx + (protocol.length + 3)
                  : currentPoint + idx) + url.length
            })
          }
        })

        bunchOfUrls = _.sortBy(bunchOfUrls, (url) => url.index) // sort by index
        bunchOfUrls = _.uniqBy(bunchOfUrls, 'index') // unique by index

        bunchOfUrls.forEach((url, index) => {
          try {
            text = text.replace(url.link, `#~${index}`) // make sure every url.link is unique
            const textBefore = text.split(`#~${index}`)[0]
            const textAfter =
              index + 1 < bunchOfUrls.length ? '' : text.split(`#~${index}`)[1]
            outputResponse.push({
              url: url.link,
              textBefore,
              textAfter,
            })
            text = text.split(`#~${index}`)[1]
          } catch (err) {
            return bunchOfUrls.length > 0
              ? outputResponse
              : [
                  {
                    url: '',
                    textBefore: isRead
                      ? this.whatsappToPreviewFormatter(message, true)
                      : this.sliceWords(
                          this.whatsappToPreviewFormatter(message, true),
                          256
                        ),
                    textAfter: '',
                  },
                ]
          }
        })

        return bunchOfUrls.length > 0
          ? outputResponse
          : [
              {
                url: '',
                textBefore: isRead
                  ? this.whatsappToPreviewFormatter(message, true)
                  : this.sliceWords(
                      this.whatsappToPreviewFormatter(message, true),
                      256
                    ),
                textAfter: '',
              },
            ]
      } else return ''
    },
    hubConversationUsernameFormatter(text) {
      const urlRegex = /@\w+/
      return text.replace(urlRegex, (uname) => this.reformatUsername(uname))
    },
    reformatUsername(uname) {
      let username = uname
      username = username.replace(/<b>(.*?)<\/b>/g, '$1')
      username = username.replace(/<i>(.*?)<\/i>/g, '$1')
      username = username.replace(/<strike>(.*?)<\/strike>/g, '$1')
      username = username.replace(/(.*?)<\/b>/g, '$1')
      username = username.replace(/(.*?)<\/i>/g, '$1')
      username = username.replace(/(.*?)<\/strike>/g, '$1')
      username = username.replace(/<br \/>/g, '\n')

      return (
        '<a href="https://instagram.com/' +
        username.replace('@', '') +
        '" style="word-break: break-all; color: #4B61DD" target="_blank">' +
        this.whatsappFormatter(username) +
        '</a>'
      )
    },
  },
}
